// src/components/Support.js
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem;
  color: ${({ theme }) => theme.text};
`;

const Heading = styled.h2`
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.link};
`;

const Question = styled.h3`
  margin-top: 1.5rem;
  color: ${({ theme }) => theme.link};
`;

const Answer = styled.p`
  margin-top: 0.5rem;
  line-height: 1.5;
`;

// FAQ Component
const FAQ = () => (
  <Container>
    <Heading>Frequently Asked Questions</Heading>

    <Question>How do I create my portfolio?</Question>
    <Answer>Simply sign up and use our AI-powered tools to generate or customize your portfolio with ease.</Answer>

    <Question>Can I use free templates?</Question>
    <Answer>Yes, we offer a variety of free templates to get you started.</Answer>

    <Question>Is my data secure?</Question>
    <Answer>We prioritize your privacy and data security by using industry-standard protections.</Answer>
  </Container>
);

// Privacy Policy Component
const PrivacyPolicy = () => (
  <Container>
    <Heading>Privacy Policy</Heading>
    <Answer>Your privacy is important to us. We collect only necessary data to provide and improve our services. We never sell your personal information.</Answer>
    <Answer>We use cookies to enhance your experience, analyze traffic, and customize content.</Answer>
    <Answer>For detailed information, please contact us.</Answer>
  </Container>
);

// Terms of Service Component
const TermsOfService = () => (
  <Container>
    <Heading>Terms of Service</Heading>
    <Answer>By using Portify, you agree to comply with all applicable laws and these terms.</Answer>
    <Answer>We reserve the right to modify the service or terms at any time without notice.</Answer>
    <Answer>Use of our service is at your own risk. We are not liable for any damages.</Answer>
  </Container>
);

export { FAQ, PrivacyPolicy, TermsOfService };
